import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import RealisationInstitutionInternationale from "../components/RealisationInstitutionInternationale";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RealisationInstitutionInternationale);
const withTranslationComponent = withTranslation(["realisations", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/RealisationInstitutionInternationale.js